module.exports = __webpack_public_path__ + "img/dview_bianliangqu.3ec0c943.jpg";